import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { PrTooltipIconComponent } from '../pr-tooltip-icon/pr-tooltip-icon.component';

@Component({
    selector: 'pr-expansion-panel',
    templateUrl: './pr-expansion-panel.component.html',
    styleUrls: ['./pr-expansion-panel.component.scss'],
    standalone: false
})
export class PrExpansionPanelComponent
  extends PrTooltipIconComponent
  implements OnInit
{
  @Input() expanded: boolean = false;
  @Input() expandable: boolean = true;
  @Input() redirect: boolean = false;
  @Input() hideToggle: boolean = false;
  @Input() display: string = 'default';

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
